module.exports = __webpack_public_path__ + "static/media/ajax-Loader.1c243f6c.gif";